module.exports = __webpack_public_path__ + "img/mitre.672557e7.svg";